import { Component } from '@angular/core';

import {VoiceService} from '../../services/voice/voice.service';
import {WordPlayBtnComponent} from './word-play-btn.component';
import {GlobalEventService} from "../../services/global-event/global-event.service";

@Component({
  selector: 'app-word-homonym-play-btn',
  template: `
    <a *ngIf="word?.wordVoice"
       class="item-sound-btn {{ on ? 'on' : '' }}"
       (click)="playSound($event)"></a>
  `,
})
export class WordHomonymPlayBtnComponent extends WordPlayBtnComponent{

  constructor(
    protected override voice: VoiceService,
    protected override globalEventSvc: GlobalEventService,
  ) {
    super(voice, globalEventSvc);
  }

}
